import cookieBarStore from './src/store'
const cookiebar = () => import('./src/components/cookiebar')
const dashboard = () => import('./src/views/settings.vue')

const install = (Vue, options) => {
  if (!options.store) {
    throw new Error('Please initalize the cookie bar with a vuex store.')
  }

  options.store.registerModule('cookiebar', cookieBarStore, { preserveState: options.store.state.cookiebar !== undefined })

  Vue.component('cookiebar', cookiebar)
}

export default { install, dashboard }
